class UrlService {
  parseQueryString(query: string): any {
    const vars = query.split('&');
    const queryString: any = {};

    for (let i = 0; i < vars.length; ++i) {
      const pair = vars[i].split('=');
      const key = decodeURIComponent(pair[0]);
      const value = decodeURIComponent(pair[1]);

      if (typeof queryString[key] === 'undefined') {
        queryString[key] = decodeURIComponent(value);
      } else if (typeof queryString[key] === 'string') {
        const arr = [queryString[key], decodeURIComponent(value)];
        queryString[key] = arr;
      } else {
        queryString[key].push(decodeURIComponent(value));
      }
    }

    return queryString;
  }

  getUrlParam<T = string>(key: string): null | T {
    const queryString = window.location.search.substring(1);
    const data: any = this.parseQueryString(queryString);

    return data[key] || null;
  }

  replaceUrl(newUrl: string) {
    if (
      typeof window !== 'undefined' &&
      window &&
      window.location &&
      window.history &&
      window.history.replaceState
    ) {
      window.history.replaceState({}, '', newUrl);
    }
  }

  removeParam(param: string) {
    if (
      typeof window !== 'undefined' &&
      window &&
      window.location &&
      window.history &&
      window.history.replaceState
    ) {
      const value = this.getUrlParam(param) || '';
      const newUrl = window.location.href
        .replace(`?${param}=${value}&`, '?')
        .replace(`?${param}=${value}`, '')
        .replace(`&${param}=${value}`, '')
        .replace(`?${param}=&`, '?')
        .replace(`?${param}=`, '')
        .replace(`&${param}=`, '')
        .replace(`?${param}&`, '?')
        .replace(`?${param}`, '')
        .replace(`&${param}`, '');

      this.replaceUrl(newUrl);
    }
  }

  removeHash() {
    if (typeof window !== 'undefined' && window && window.location) {
      window.location.hash = '';
    }
  }

  popup(url: string, options: any): Window {
    const optionsStr = Object.keys(options)
      .reduce((acc: Array<string>, key: string) => {
        acc.push(`${key}=${options[key]}`);
        return acc;
      }, [])
      .join(',');

    return window.open(url, 'popup', optionsStr);
  }

  openTab(url: string): void {
    // window.open(url, "_blank");
    window.open(url, 'BLANK');

    // const aLink = window.document.createElement("a");
    // aLink.target = "_blank";
    // aLink.href = url;

    // const event = window.document.createEvent("MouseEvents");
    // event.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    // aLink.dispatchEvent(event);
  }
}

export default new UrlService();
